$(document).ready(function() {
    $('.body-filters select').on('change', function() {

        // Grabs the selected options

        var vehicle_opt = $('.vehicle option:selected');
        var conversion_opt = $('.conversion option:selected');

        /*
            Check so see if vehicle, conversion or both are selected
        
            > ONLY Vehicle Selected
            > ONLY Conversion Selected
            > NONE Selected
            > BOTH Selected
        */

        if(vehicle_opt.index() != 0 && conversion_opt.index() == 0) {
            $('.bodybuilders .item').each(function() {
                $(this).attr('data-' + vehicle_opt.val()).length > 0
                    ? $(this).removeClass('hide')
                    : $(this).addClass('hide');
            });
        } else if(conversion_opt.index() != 0 && vehicle_opt.index() == 0) {
            $('.bodybuilders .item').each(function() {
                var searchable = [
                    $(this).attr('data-daily').split(','),
                    $(this).attr('data-eurocargo').split(','),
                    $(this).attr('data-xway').split(','),
                    $(this).attr('data-sway').split(',')
                ];

                [...new Set(searchable.flat())].includes(conversion_opt.val()) 
                    ? $(this).removeClass('hide')
                    : $(this).addClass('hide');
            });
        } else if(conversion_opt.index() == 0 && vehicle_opt.index() == 0) {
            $('.bodybuilders .item').each(function() {
                $(this).removeClass('hide');
            });
        } else {
            $('.bodybuilders .item').each(function() {
                var searchable = $(this).attr('data-' + vehicle_opt.val()).split(',');

                searchable.includes(conversion_opt.val())
                    ? $(this).removeClass('hide')
                    : $(this).addClass('hide');
            });
        }

        // If nothing matches the filters, display an error message

        $('.bodybuilder .error').css('display', ($('.bodybuilders .item:not(.hide)').length == 0) ? 'block' : 'none');

        $(this).blur();
    });
});